import React, { useState } from 'react';
import "./style.css"
import { Collapse } from 'react-collapse'
//import { AiOutlineSearch } from 'react-icons/ai'
//import { NavLink } from 'react-router-dom'
import { IoIosArrowDown } from "react-icons/io";
import SideNav from './../../../components/SideNav_OG';
import ConsultasPendentes from './../../../components/Display_Organizador/Listar_Consultas/Pendentes';
import ConsultasConfirmadas from './../../../components/Display_Organizador/Listar_Consultas/Confirmadas';
import ConsultasRealizadas from './../../../components/Display_Organizador/Listar_Consultas/Passadas';
import ConsultasRecusadas from './../../../components/Display_Organizador/Listar_Consultas/Recusadas';
import ListarConsultas from '../../../components/Display_Organizador/Listar_Consultas'
//import ConsultasEncaminhadas from './../../../components/Display_Organizador/Listar_Consultas/Encaminhadas';

export default function Tela_Consultas() {
    //let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    let [confirmadas, setConfirmadas] =  useState(false);
    let [passadas, setPassadas] =  useState(false);
    let [recusadas, setRecusadas] =  useState(false);
    //let [options2, setOptions2] = use State(false);


    return (
        <>
            <SideNav />
            <div id="top-Consulta"></div>

            <div id="main-Consulta"> 
                    <p id="Consulta">Consultas Pendentes</p>
                    <hr id="divider-Consulta" />
                    <div id="arrow-Consulta">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"7vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-Consulta">
                        <ListarConsultas status='Pendente' />
                         </div>
                    </Collapse>     
                    <p id="Consulta">Consultas Confirmadas</p>
                    <hr id="divider-Consulta" />
                    <br></br>
                    <div id="arrow-Consulta">
                        <IoIosArrowDown
                            onClick={() =>
                                setConfirmadas(!confirmadas)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={confirmadas}>
                        <div id="collapsed-Consulta">
                        <ListarConsultas status='Confirmada' />
                         </div>
                    </Collapse>     
                    <p id="Consulta">Consultas Realizadas</p>
                    <hr id="divider-Consulta" />
                    <br></br>
                    <div id="arrow-Consulta">
                        <IoIosArrowDown
                            onClick={() =>
                                setPassadas(!passadas)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={passadas}>
                        <div id="collapsed-Consulta">
                        <ListarConsultas status='Realizada' />
                         </div>
                    </Collapse>     
                    <p id="Consulta">Consultas Recusadas</p>
                    <hr id="divider-Consulta" />
                    <br></br>
                    <div id="arrow-Consulta">
                        <IoIosArrowDown
                            onClick={() =>
                                setRecusadas(!recusadas)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={recusadas}>
                        <div id="collapsed-Consulta">
                        <ListarConsultas status='Recusada' />
                         </div>
                    </Collapse>      
            </div>
        </>
    );
}